export default "__VITE_ASSET__ddfe217d__"